import { IResourceComponentsProps } from "@refinedev/core";
import { AntdShowInferencer } from "@refinedev/inferencer/antd";

export const UserShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdShowInferencer />;
};
